import React, { useState } from "react";
import styled from "styled-components";

const Section = styled.section`
  background: #fff;
  padding: 64px 0 48px 0;
  border-bottom: 1.5px solid #222;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #b28767;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 1px;
`;

const ContactForm = styled.form`
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  @media (max-width: 600px) {
    max-width: 100%;
    padding: 0 8px;
    gap: 10px;
  }
`;

const Input = styled.input`
  padding: 12px;
  border: 1.5px solid #222;
  border-radius: 8px;
  font-size: 1rem;
  background: #f8f9fa;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  @media (max-width: 600px) {
    font-size: 0.95rem;
    padding: 10px;
  }
`;

const Textarea = styled.textarea`
  padding: 12px;
  border: 1.5px solid #222;
  border-radius: 8px;
  font-size: 1rem;
  background: #f8f9fa;
  min-height: 100px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  @media (max-width: 600px) {
    font-size: 0.95rem;
    padding: 10px;
    min-height: 70px;
  }
`;

const Button = styled.button`
  background: #fff;
  color: #222;
  border: 1.5px solid #222;
  padding: 12px 36px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  &:hover {
    background: #222;
    color: #fff;
  }
`;
const Contact = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviado(false);

    await fetch(
      "https://prismaassessoria.app.n8n.cloud/webhook/formulario-contato",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nome, email, mensagem }),
      }
    );

    setEnviado(true);
    setNome("");
    setEmail("");
    setMensagem("");
  };

  return (
    <Section id="contato">
      <Title>Contato</Title>
      <ContactForm onSubmit={handleSubmit}>
        <Input
          type="text"
          placeholder="Seu nome"
          required
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />
        <Input
          type="email"
          placeholder="Seu e-mail"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Textarea
          placeholder="Sua mensagem"
          required
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value)}
        />
        <Button type="submit">Enviar</Button>
        {enviado && (
          <div style={{ color: "#b28767", marginTop: 10, textAlign: "center" }}>
            Mensagem enviada com sucesso!
          </div>
        )}
      </ContactForm>
    </Section>
  );
};

export default Contact;
